"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/regeneratorRuntime"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _Menu = require("../Menu");
var _MenuItem = _interopRequireDefault(require("../MenuItem"));
var _context2 = _interopRequireDefault(require("../Theme/context"));
var _CheckboxIconContainerComponent = _interopRequireDefault(require("./CheckboxIconContainerComponent"));
var _enterNextFocus = _interopRequireDefault(require("./enterNextFocus"));
var _excluded = ["menuActions"],
  _excluded2 = ["inputRef", "ComponentFromParent", "classNames", "menuActions", "disabled", "label", "children"],
  _excluded3 = ["classNames", "disableUseStyle", "size", "multiple", "disabled", "noOptionsText", "onChange", "onBlur", "Component", "PaperProps", "effect", "containerRef", "className", "parentButtonPaperDisabled", "checkboxIconToEnd", "getCheckboxIconButtonProps", "MenuItemComponent"],
  _excluded4 = ["variant", "color"],
  _excluded5 = ["value", "menu"];
var InputForCheckbox = /*#__PURE__*/_react["default"].memo(/*#__PURE__*/_react["default"].forwardRef(function (_ref2, _ref3) {
  var menuActions = _ref2.menuActions,
    props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded);
  var _ref = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    var t = setTimeout(function () {
      var values = menuActions.current.actions.getValue();
      var value = values.indexOf(props.value) > -1;
      if (_ref.current) {
        _ref.current.value = !!value;
      }
    }, 1);
    return function () {
      if (t) {
        clearTimeout(t);
      }
    };
  }, []);
  return /*#__PURE__*/_react["default"].createElement("input", {
    ref: function ref(e) {
      _ref.current = e;
      if (_ref3) {
        if (typeof _ref3 === 'function') {
          _ref3(e);
        } else if (_ref3 && typeof _ref3 === 'object') {
          _ref3.current = e;
        }
      }
    },
    value: props.value || false,
    disabled: props.disabled || false,
    type: 'checkbox',
    className: props.className,
    onChange: function onChange(e) {
      e.preventDefault();
    },
    onKeyDown: function onKeyDown(e) {
      (0, _enterNextFocus["default"])(e);
    }
  });
}), function (prevProps, nextProps) {
  return prevProps.disabled === nextProps.disabled && prevProps.value === nextProps.value;
});
var MenuItemComponentForCheckbox = /*#__PURE__*/_react["default"].forwardRef(function (_ref4, ref) {
  var inputRef = _ref4.inputRef,
    _ref4$ComponentFromPa = _ref4.ComponentFromParent,
    ComponentFromParent = _ref4$ComponentFromPa === void 0 ? _MenuItem["default"] : _ref4$ComponentFromPa,
    classNames = _ref4.classNames,
    menuActions = _ref4.menuActions,
    disabled = _ref4.disabled,
    label = _ref4.label,
    children = _ref4.children,
    props = (0, _objectWithoutProperties2["default"])(_ref4, _excluded2);
  var inputProps = {
    menuActions: menuActions,
    value: false,
    ref: inputRef,
    className: classNames.hiddenInput,
    disabled: disabled
  };
  var c = children ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children, /*#__PURE__*/_react["default"].createElement(InputForCheckbox, inputProps)) : children;
  var l = label && !children ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, label, /*#__PURE__*/_react["default"].createElement(InputForCheckbox, inputProps)) : label;
  return /*#__PURE__*/_react["default"].createElement(ComponentFromParent, Object.assign({}, props, {
    ref: ref,
    disabled: disabled,
    label: l
  }), c);
});
var _default = exports["default"] = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var _value, _menu, _restPaperProps$Conte, _restPaperProps$Conte2, _restPaperProps$Conte3, _rest$MenuItemProps;
  var classNames = props.classNames,
    disableUseStyle = props.disableUseStyle,
    size = props.size,
    multiple = props.multiple,
    disabled = props.disabled,
    _props$noOptionsText = props.noOptionsText,
    noOptionsText = _props$noOptionsText === void 0 ? 'No options' : _props$noOptionsText,
    _onChange = props.onChange,
    onBlur = props.onBlur,
    _props$Component = props.Component,
    Component = _props$Component === void 0 ? _Menu.MenuBase : _props$Component,
    _props$PaperProps = props.PaperProps,
    PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
    effect = props.effect,
    containerRef = props.containerRef,
    className = props.className,
    parentButtonPaperDisabled = props.parentButtonPaperDisabled,
    checkboxIconToEnd = props.checkboxIconToEnd,
    getCheckboxIconButtonProps = props.getCheckboxIconButtonProps,
    _props$MenuItemCompon = props.MenuItemComponent,
    MenuItemComponent = _props$MenuItemCompon === void 0 ? _MenuItem["default"] : _props$MenuItemCompon,
    rest2 = (0, _objectWithoutProperties2["default"])(props, _excluded3);
  var variant = PaperProps.variant,
    color = PaperProps.color,
    restPaperProps = (0, _objectWithoutProperties2["default"])(PaperProps, _excluded4);
  var value = rest2.value,
    menu = rest2.menu,
    rest = (0, _objectWithoutProperties2["default"])(rest2, _excluded5);
  value = typeof value === 'object' && (_value = value) !== null && _value !== void 0 && _value.length ? value : [];
  menu = typeof menu === 'object' && (_menu = menu) !== null && _menu !== void 0 && _menu.length ? menu : [];
  var themeContext = (0, _react.useContext)(_context2["default"]);
  var useStyle = themeContext.useStyle;
  if (typeof useStyle === 'function' && !disableUseStyle) {
    useStyle(classNames);
  }
  var _useState = (0, _react.useState)(value),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    inputValue = _useState2[0],
    setValue = _useState2[1];
  var menuActions = (0, _react.useRef)({});
  (0, _react.useEffect)(function () {
    if (effect) {
      effect({
        actions: {
          setValue: setValue,
          getValue: function getValue() {
            return value;
          },
          focus: function focus() {}
        }
      });
    }
    return function () {
      if (effect) {
        effect({
          actions: {
            setValue: function setValue() {},
            getValue: function getValue() {},
            focus: function focus() {}
          }
        });
      }
    };
  });
  var lastPropsValue = (0, _react.useRef)(props.value);
  (0, _react.useEffect)(function () {
    try {
      if (typeof props.value !== 'undefined' && JSON.stringify(lastPropsValue.current) !== JSON.stringify(props.value)) {
        if (JSON.stringify(inputValue) !== JSON.stringify(props.value)) {
          var _props$value;
          lastPropsValue.current = props.value;
          var newValue = typeof props.value === 'object' && (_props$value = props.value) !== null && _props$value !== void 0 && _props$value.length ? props.value : [];
          setValue(newValue);
        }
      }
    } catch (e) {
      console.log(e);
    }
  }, [props.value]);
  var inputRef = (0, _react.useRef)();
  return /*#__PURE__*/_react["default"].createElement(Component, Object.assign({}, rest, {
    ref: ref,
    menu: menu.length ? menu : [{
      label: noOptionsText,
      disabled: true
    }],
    PaperProps: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({
      size: 'none',
      elevation: 0,
      disabled: disabled,
      color: color,
      variant: 'inline'
    }, restPaperProps), {}, {
      className: (0, _clsx["default"])(classNames.checkboxBase, className)
    }, parentButtonPaperDisabled ? {
      ContentComponentProps: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, restPaperProps.ContentComponentProps ? restPaperProps.ContentComponentProps : {}), {}, {
        ContentComponentProps: (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, (_restPaperProps$Conte = restPaperProps.ContentComponentProps) !== null && _restPaperProps$Conte !== void 0 && _restPaperProps$Conte.ContentComponentProps ? restPaperProps.ContentComponentProps.ContentComponentProps : {}), {}, {
          className: (0, _clsx["default"])(classNames.checkboxBaseMenuPaperEnableOverflow, (_restPaperProps$Conte2 = restPaperProps.ContentComponentProps) === null || _restPaperProps$Conte2 === void 0 ? void 0 : (_restPaperProps$Conte3 = _restPaperProps$Conte2.ContentComponentProps) === null || _restPaperProps$Conte3 === void 0 ? void 0 : _restPaperProps$Conte3.className)
        })
      })
    } : {}),
    MenuItemComponent: MenuItemComponentForCheckbox,
    MenuItemProps: (0, _objectSpread2["default"])((0, _objectSpread2["default"])((0, _objectSpread2["default"])((0, _objectSpread2["default"])({
      Component: 'div',
      variant: variant,
      size: size,
      disabled: disabled
    }, checkboxIconToEnd ? {
      EndIconContainerComponent: function EndIconContainerComponent(props) {
        return (0, _CheckboxIconContainerComponent["default"])((0, _objectSpread2["default"])((0, _objectSpread2["default"])({
          getCheckboxIconButtonProps: getCheckboxIconButtonProps
        }, props), {}, {
          className: (0, _clsx["default"])(classNames.checkboxIcon, props.className)
        }));
      },
      endIcon: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null)
    } : {
      StartIconContainerComponent: function StartIconContainerComponent(props) {
        return (0, _CheckboxIconContainerComponent["default"])((0, _objectSpread2["default"])((0, _objectSpread2["default"])({
          getCheckboxIconButtonProps: getCheckboxIconButtonProps
        }, props), {}, {
          className: (0, _clsx["default"])(classNames.checkboxIcon, props.className)
        }));
      },
      startIcon: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null)
    }), parentButtonPaperDisabled ? {
      disableElevation: false,
      enableBackground: true
    } : {}), rest.MenuItemProps ? rest.MenuItemProps : {}), {}, {
      className: (0, _clsx["default"])(classNames.checkboxMenuItem, (_rest$MenuItemProps = rest.MenuItemProps) === null || _rest$MenuItemProps === void 0 ? void 0 : _rest$MenuItemProps.className),
      inputRef: inputRef,
      ComponentFromParent: MenuItemComponent,
      classNames: classNames,
      menuActions: menuActions
    }),
    value: inputValue,
    selectable: true,
    multiple: multiple,
    onChange: function () {
      var _onChange2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee(e, value) {
        return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return setValue(value);
            case 2:
              if (!onBlur) {
                _context.next = 7;
                break;
              }
              _context.next = 5;
              return onBlur(e, value);
            case 5:
              _context.next = 10;
              break;
            case 7:
              if (!_onChange) {
                _context.next = 10;
                break;
              }
              _context.next = 10;
              return _onChange(e, value);
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function onChange(_x, _x2) {
        return _onChange2.apply(this, arguments);
      }
      return onChange;
    }(),
    effect: function effect(p) {
      var actions = p.actions;
      menuActions.current.actions = actions;
    }
  }));
});